import { Stack, Typography } from '@optimus-web/core';

interface RowTextCellProps {
    title: React.ReactNode;
    description?: React.ReactNode;
}

export const RowTextCell: React.FC<RowTextCellProps> = ({ title, description }) => (
    <Stack vertical>
        <Typography textStyle="bodyMedium" as="div">
            {title}
        </Typography>
        {description && (
            <Typography textStyle="bodyMedium" variant="tertiary" as="div">
                {description}
            </Typography>
        )}
    </Stack>
);
